// Polyfills are loaded via webpack entry points (see config/webpack.base.config.js)
// This ensures they load before React and other dependencies
import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import "./styles/index";
import App from "./router";
import { BrowserRouter } from "react-router-dom";
import { antdThemeConfig } from "./styles/antd-override/antd-config";

console.log(typeof Object.hasOwn); // 应输出 "function"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ConfigProvider locale={zhCN} theme={antdThemeConfig}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
